import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EventDetail from "./pages/EventDetail";
import ManageVendors from "./pages/Dashboard/ManageVendors";
import Signup from "./pages/Signup";
import EventInsights from "./pages/Dashboard/EventData";
import EditStore from "./pages/EditStore";
import ResetPassword from "./pages/ResetPassword";
import LandingPage from "./pages/LandingPage";
import Docs from "./pages/Docs";
import FAQ from "./pages/FAQ";
import ScrollToTop from "./assets/components/ScrollToTop";

export const routes = [
    {
        path: "/",
        element: <Login />,
        isPrivate: false,
    },
    // {
    //     path: "/",
    //     element: <LandingPage />,
    //     isPrivate: false,
    // },
    {
        path: "/login",
        element: <Login />,
        isPrivate: false,
    },
    {
        path: "/register",
        element: <Signup />,
        isPrivate: false,
    },

    {
        path: "/LandingPage",
        element: <LandingPage />,
        isPrivate: false,
    },

    {
        path: "/Docs",
        element: <Docs />,
        isPrivate: false,
    },

    {
        path: "/FAQ",
        element: <FAQ />,
        isPrivate: false,
    },

    {
        path: "/reset-password/:token",
        element: <ResetPassword />,
        isPrivate: false,
    },
    {
        path: "/dashboard",
        element: <Dashboard />,
        isPrivate: true,
    },
    {
        path: "/dashboard/event/:eventId",
        element: <EventDetail />,
        isPrivate: true,
    },
    {
        path: "/dashboard/event/:eventId/invitations",
        element: <ManageVendors />,
        isPrivate: true,
    },
    {
        path: "/dashboard/event/:eventId/edit",
        element: <EditStore />,
        isPrivate: true,
    },
    {
        path: "/dashboard/event/:eventId/insights",
        element: <EventInsights />,
        isPrivate: true,
    },
    {
        path: "*",
        element: (
            <div className="h-screen w-screen flex flex-col justify-center items-center">
                <p className="text-[40px] font-semibold">404</p>
                <p className="text-[30px] font-semibold">Page not found</p>
            </div>
        ),
        isPrivate: false,
    },
];
